
<div>
  <button
    @click="$emit('undo')"
    class="btn-icon light-grey md undo"
    :disabled="!can.undo"
    v-tooltip="'Undo'"
  >
    <span class="sr-only">Undo previous action</span>
    <icon class="undo"></icon>
  </button>
  <button
    @click="$emit('redo')"
    class="btn-icon light-grey md redo"
    :disabled="!can.redo"
    v-tooltip="'Redo'"
  >
    <span class="sr-only">Redo previous action</span>
    <icon class="redo"></icon>
  </button>
  <span class="divider"></span>
  <button
    v-if="$can('viewShares', model)"
    @click="$emit('share')"
    class="btn-icon grey md share"
    v-tooltip="'Share'"
  >
    <icon class="share"></icon>
    <span class="sr-only">Share</span>
  </button>
</div>
